function updateSwtachesAddtoCart() {
    const swatches = document.querySelectorAll('.swatch-custom-image');
    swatches?.forEach(swatch => {
        swatch.removeEventListener('click', handleSwatchClick);
        swatch.addEventListener('click', handleSwatchClick);
    });
}

function handleSwatchClick() {
    const productHandle = this.getAttribute('swatch-url').split('/products/')[1];  

    if (productHandle) {
        fetch(`/products/${productHandle}.js`)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(product => { 
                const liElement = this.closest('li.grid__item'); 
                const addToCartButton = liElement.querySelector('.card-information__button > add-to-cart');
                const soldOutButton = liElement.querySelector('.card-information__button .btn--sold-out');
                const displayVariant = product.variants.find((variant) => variant.available) || product.variants[0];

                if (product.available && displayVariant) {
                    if (addToCartButton) {
                        addToCartButton.style.display = 'flex';
                        addToCartButton.setAttribute('data-variant-id', displayVariant.id);

                        const defaultLabel = addToCartButton.dataset.defaultLabel || 'Add to cart';
                        const preorderLabel = addToCartButton.dataset.preorderLabel || 'Pre-Order NOW';
                        /*const label = ['ST02', 'ST09'].includes((displayVariant.sku || '').toUpperCase()) ? preorderLabel : defaultLabel;*/
                        const label = ['LNCT01111',].includes((displayVariant.sku || '').toUpperCase()) ? preorderLabel : defaultLabel;
                        const buttonText = addToCartButton.querySelector('.add-to-cart__text');

                        if (buttonText) {
                            buttonText.textContent = label;
                        }
                    }
                    if (soldOutButton) {
                        soldOutButton.style.display = 'none';
                    }
                } else {
                    if (addToCartButton) {
                        addToCartButton.style.display = 'none';
                    }
                    if (soldOutButton) {
                        soldOutButton.style.display = 'block';
                    }
                }
            })
            .catch(error => {
                console.error('Error fetching product:', error);
            });
    }
}
window.addEventListener('load', function() {
    setTimeout(() => {
        updateSwtachesAddtoCart()
    }, 500);
});
